<template>
    <div>
        <h1 class="m-0 mb-6">{{ $l10n.__('Rapports') }}</h1>
        <div class="white-bkg p-5 b-1 br">
            <simple-search-list
                :datas="reports"
                :columns="columns"
                :placeholder="$t.__('pages.reports.ReportsListing.search_report')"
                :rowNumberLabel="$t.__('common.labels.reports')"
                :cumulioAuth="cumulioAuth"
            >
            </simple-search-list>
        </div>
    </div>
</template>
<script>
import ReportsApi from 'api/reports/reports';
import SimpleSearchList from 'vcomponents/dashboard/cards/SimpleSearchList.vue';

export default {
    components: {
        SimpleSearchList,
    },
    data() {
        return {
            reports: [],
            columns: [
                {
                    label: this.$l10n.__('Nom'),
                    name: 'name',
                    isDate: false,
                    width: null,
                    sortable: true,
                    isLink: true,
                },
                {
                    label: this.$l10n.__('Description'),
                    name: 'subtitle',
                    isDate: false,
                    width: null,
                    sortable: false,
                    isLink: true,
                },
            ],
            cumulioAuth: {},
        };
    },
    created() {
        this.getReports();
    },
    methods: {
        getReports() {
            ReportsApi.getReports()
                .then((response) => {
                    this.reports = response.data.data;
                    if (
                        response.data.aggregations.cumulio &&
                        response.data.aggregations.cumulio.key
                    ) {
                        this.cumulioAuth = response.data.aggregations.cumulio;
                    }
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        close: true,
                        text: this.$l10n.__('Problème lors de la récupération des données'),
                    });
                });
        },
    },
};
</script>
